import { Card, message, Modal } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useCostumeActions, useCostumes } from "../../../../hooks/useCostume";
import { CostumeTable } from "../components/CostumeTable";
import { CostumeFilter } from "../components/CostumeFilter";
import { EditCostumeForm } from "../components/EditCostumeForm";
import { useAuth } from "../../../../hooks/useAuth";

export function EventRobePage() {
  const { id: eventId } = useParams();
  const [filter, setFilter] = useState({ page: 1, limit: 10, event: eventId });
  const { data: costumes, pagination, isLoading } = useCostumes(filter);
  const { updateCostume, deleteCostume } = useCostumeActions();

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedCostume, setSelectedCostume] = useState(null);
  const { data: user } = useAuth();

  const handleEdit = (costume) => {
    setSelectedCostume(costume);
    setEditModalVisible(true);
  };

  const handleDelete = async (costumeId) => {
    Modal.confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa trang phục này?",
      okText: "Xóa",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          await deleteCostume.mutateAsync(costumeId);
          message.success("Xóa trang phục thành công!");
        } catch (error) {
          message.error("Xóa trang phục thất bại!");
        }
      },
    });
  };

  const handleEditSubmit = async (costumeId, values) => {
    try {
      await updateCostume.mutateAsync({
        id: costumeId,
        data: values,
      });
      message.success("Cập nhật trang phục thành công!");
      setEditModalVisible(false);
      setSelectedCostume(null);
    } catch (error) {
      message.error("Cập nhật trang phục thất bại!");
    }
  };

  const handleEditCancel = () => {
    setEditModalVisible(false);
    setSelectedCostume(null);
  };

  const handleTableChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Danh sách mượn/mua áo tràng</h2>
          <p style={{ margin: "8px 0 0 0", color: "#666" }}>
            Tổng số: {pagination.total} mục
          </p>
        </div>
      </div>

      <Card>
        <CostumeFilter filter={filter} onFilterChange={setFilter} />
        <CostumeTable
          costumes={costumes}
          filter={filter}
          pagination={pagination}
          isLoading={isLoading}
          onTableChange={handleTableChange}
          onEdit={handleEdit}
          onDelete={handleDelete}
          userRole={user?.role}
        />

        <EditCostumeForm
          visible={editModalVisible}
          costume={selectedCostume}
          onCancel={handleEditCancel}
          onSubmit={handleEditSubmit}
          loading={updateCostume.isLoading}
        />
      </Card>
    </div>
  );
}
